export default __webpack_public_path__ + "static/media/보수.9a742ac8.png";